import { render, staticRenderFns } from "./SessionLiveMetadata.vue?vue&type=template&id=35f06680&scoped=true"
import script from "./SessionLiveMetadata.js?vue&type=script&lang=js&external"
export * from "./SessionLiveMetadata.js?vue&type=script&lang=js&external"
import style0 from "./SessionLiveMetadata.vue?vue&type=style&index=0&id=35f06680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f06680",
  null
  
)

export default component.exports